document.querySelectorAll(".mega-menu__link").forEach((elem) => {
  if (elem.textContent.includes("|")) {
    const title = elem.textContent
      .split("|")[0]
      .replace(/[\n\r]+|[\s]{2,}/g, " ")
      .trim();
    const img = elem.textContent
      .split("|")[1]
      .replace(/[\n\r]+|[\s]{2,}/g, " ")
      .trim();
    elem.innerHTML = `
            <div style="width: 225px">
              <img
                  src="${img}"
                  alt=""
                  width=""
                  height=""
                  style="max-width: 225px; height: auto; margin-bottom: .4rem;">
                <div style="text-align: center; position: relative; top: -7rem;">
                  <div style="text-align: center; position: relative; background-color: white; padding: 1rem; margin: 0 25px;">
                    ${title}
                  </div>
                </div>
              </div>
        `;
    elem.closest(".mega-menu__list").getElementsByClassName.gridTemplateColumns = "repeat(5, minmax(0, 1fr))";
  }
});

document.querySelectorAll(".menu-drawer__menu-item").forEach((elem) => {
  if (elem.textContent.includes("|")) {
    const title = elem.textContent
      .split("|")[0]
      .replace(/[\n\r]+|[\s]{2,}/g, " ")
      .trim();
    const img = elem.textContent
      .split("|")[1]
      .replace(/[\n\r]+|[\s]{2,}/g, " ")
      .trim();
    elem.innerHTML = `
            <div style="width: 225px">
              <img
                  src="${img}"
                  alt=""
                  width=""
                  height=""
                  style="max-width: 225px; height: auto; margin-bottom: .4rem;">
                <div style="text-align: center; position: relative; top: -7rem;">
                  <div style="text-align: center; position: relative; background-color: white; padding: 1rem; margin: 0 25px; font-size: 16px;">
                    ${title}
                  </div>
                </div>
              </div>
        `;
  }
});
